<fui-action [attr.title]="title | translate">
    <fui-icon [width]="iconSize" [height]="iconSize" [icon]="icon" [class]="iconClass"></fui-icon>
</fui-action>
